export class AuthenticationUtility {
    static isDivisionGateKeeper(roles: string[]): boolean {
        return roles.some(r => r.toLowerCase().includes('divisiongatekeepers'));
    }

    static isAreaGateKeeper(roles: string[]): boolean {
        return roles.some(r => r.toLowerCase().includes('areagatekeepers'));
    }

    static isITAdmin(roles: string[]): boolean {
        return roles.some(r => r.toLowerCase().includes('applicationadmin'));
    }

    static isGateKeeper(roles: string[]): boolean {
        return (
            AuthenticationUtility.isDivisionGateKeeper(roles) ||
            AuthenticationUtility.isAreaGateKeeper(roles)
        );
    }

    static isRequestor(roles: string[]): boolean {
        return (
            !AuthenticationUtility.isDivisionGateKeeper(roles) &&
            !AuthenticationUtility.isAreaGateKeeper(roles)
        );
    }
}